export function WindowSize(standardWidth,standardHeight,gubun,remoteVideo,android) {
  
    const body = document.querySelector("body");
    const root = document.querySelector("#Range");

    //const TipBox = document.querySelector("#Tip_popup");
    //const WonBox = document.querySelector("#WonBox_popup");
    //const GuideText = document.querySelector("#GuideText_popup");
    //const Timer = document.querySelector("#Timer");
    
    
    if(gubun!=='PC90')
    {
      root.style.width = '100%';
      root.style.height = '100%';
      root.style.paddingTop = `0px`;//`${remoteVideo}px`;
      
      root.style.scale = 1;
      //TipBox.style.scale = 1;
      //WonBox.style.scale = 1;
      //GuideText.style.scale = 1;
      //Timer.style.scale = 1;
  
      root.style.zoom = 1;
      //TipBox.style.zoom = 1;
      //WonBox.style.zoom = 1;
      //GuideText.style.zoom = 1;
      //Timer.style.zoom = 1;
    }
    else
    {
      root.style.width = `${standardWidth}px`;
      root.style.height = `${standardHeight}px`;
      root.style.paddingTop = `0px`;
      
      let width = body.clientWidth;
      let height = (width * standardHeight) / standardWidth;
  
      if (height > body.clientHeight) {
        height = body.clientHeight;
        width = (height * standardWidth) / standardHeight;
  
  
        if(android==='android')
        {
          root.style.zoom = width / standardWidth; 
          //TipBox.style.zoom = width / standardWidth;
          //WonBox.style.zoom = width / standardWidth; 
          //GuideText.style.zoom = width / standardWidth;
          //Timer.style.zoom = width / standardWidth;
        }
        else
        {
          root.style.scale = width / standardWidth; 
          //TipBox.style.scale = width / standardWidth;
          //WonBox.style.scale = width / standardWidth; 
          //GuideText.style.scale = width / standardWidth;
          //Timer.style.scale = width / standardWidth;
        }
      }
      else
      {
        if(android==='android')
        {
          root.style.zoom = height / standardHeight;
          //TipBox.style.zoom = height / standardHeight;
          //WonBox.style.zoom = height / standardHeight; 
          //GuideText.style.zoom = height / standardHeight;
          //Timer.style.zoom = height / standardHeight;
        }
        else
        {
          root.style.scale = height / standardHeight;
          //TipBox.style.scale = height / standardHeight;
          //WonBox.style.scale = height / standardHeight; 
          //GuideText.style.scale = height / standardHeight;
          //Timer.style.scale = height / standardHeight;
        }
      }
      
    }
  
  }